// Pure poll logic shared by the server (create-post validation, projection)
// and the web client (composer validation). No I/O, no clock — callers pass
// `now`. Mirrors the `reactions.ts` shared-core convention.
export const POLL_MIN_OPTIONS = 2;
export const POLL_MAX_OPTIONS = 4;
export const POLL_OPTION_MAX_LEN = 55;
/** Allowed poll durations, in days. The composer offers exactly these. */
export const POLL_DURATION_DAYS = [1, 3, 7];
export const DEFAULT_POLL_DURATION_DAYS = 7;
/** Who can see which option each person voted for. Chosen by the author at
 *  create time and immutable afterwards — voters cast under that promise. */
export const POLL_VISIBILITIES = ['anonymous', 'public'];
export const DEFAULT_POLL_VISIBILITY = 'anonymous';
export function isPollVisibility(value) {
    return POLL_VISIBILITIES.includes(value);
}
/** Max voters previewed per option on a public poll (avatars on the row). */
export const POLL_VOTER_PREVIEW_LIMIT = 3;
/** Validate a poll's option labels. Trims each; enforces count, non-empty,
 *  length cap, and uniqueness (case-sensitive, post-trim). Pure — the same
 *  rule runs at the web boundary and re-runs server-side (defense in depth). */
export function validatePollOptions(options) {
    if (options.length < POLL_MIN_OPTIONS || options.length > POLL_MAX_OPTIONS) {
        return { ok: false, reason: 'count' };
    }
    const trimmed = options.map((o) => o.trim());
    if (trimmed.some((o) => o.length === 0))
        return { ok: false, reason: 'empty' };
    if (trimmed.some((o) => o.length > POLL_OPTION_MAX_LEN))
        return { ok: false, reason: 'too_long' };
    if (new Set(trimmed).size !== trimmed.length)
        return { ok: false, reason: 'duplicate' };
    return { ok: true };
}
export function isValidPollDuration(days) {
    return POLL_DURATION_DAYS.includes(days);
}
/** A poll is closed once its close time is reached. Injected `now` keeps this
 *  deterministic in tests and consistent between server and client. */
export function isPollClosed(closesAt, now) {
    return closesAt.getTime() <= now.getTime();
}
/** Whether a viewer may see a poll's results (tallies, and on a public poll
 *  the voters). Voting reveals them, closing reveals them to everyone, and the
 *  author always sees how their own poll is going — they cannot vote to
 *  reveal without skewing it. Visibility (anonymous vs public) is orthogonal:
 *  it decides whether voters are ever named, not whether results are shown. */
export function isPollRevealed(input) {
    return input.viewerVoted || input.closed || input.viewerIsAuthor;
}
//# sourceMappingURL=polls.js.map